import React from 'react';
import './daysBanner.style.scss';
import { useDateContext } from '../../contexts/dates.context';

const DaysBanner = ({ dayFlag, nextWeek }) => {

    const { currentDate, currentWeekDates, nextWeekDates } = useDateContext();
    const bannerDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    const getDayNumber = (dateString) => {
        const date = new Date(dateString);
        return date.getDate();
    };

    return (
        <div className='section tight'>
            {dayFlag === true ? (
                <h1>
                    <strong>{currentDate.dayOfWeek}</strong> {currentDate.month} {currentDate.dayOfMonth}, {currentDate.year}
                </h1>
            ) : (
                null
            )}
            {
                nextWeek === true ? (
                    <div className="days-banner">
                        {nextWeekDates.map((date, index) => (
                            <div key={index} className="banner-day">
                                <p>{getDayNumber(date)}</p>
                                <p>{bannerDays[index]}</p>
                            </div>
                        ))}
                        {/* <button onClick={current}>CurrentDate</button> */}
                    </div>
                ) : (
                    <div className="days-banner">
                        {currentWeekDates.map((date, index) => (
                            <div key={index} className="banner-day">
                                <p>{getDayNumber(date)}</p>
                                <p>{bannerDays[index]}</p>
                            </div>
                        ))}
                        {/* <button onClick={current}>CurrentDate</button> */}
                    </div>
                )
            }
        </div>
    );
};

export default DaysBanner;
